export const KitSnackDuration = {
  LONG: 3500,
  SHORT: 2000,
  SUPER_LONG: 10000,
};
